module.exports = __webpack_public_path__ + "img/xuebitu.b0cbe40a.jpg";